import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "payments-block__middle replenishment-qr" }
const _hoisted_2 = { class: "replenishment-qr__qr" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "viet-qr-amount"
}
const _hoisted_5 = { class: "viet-qr-amount__label" }
const _hoisted_6 = { class: "viet-qr-amount__value" }
const _hoisted_7 = { class: "for-copy" }
const _hoisted_8 = { class: "viet-qr-amount__hint" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 2,
  class: "viet-qr-vnd-warning"
}
const _hoisted_11 = { class: "viet-qr-vnd-warning__text" }
const _hoisted_12 = {
  key: 0,
  class: "viet-qr-vnd-warning__sums"
}
const _hoisted_13 = {
  key: 3,
  class: "viet-qr-instruction"
}
const _hoisted_14 = { class: "viet-qr-instruction__title" }
const _hoisted_15 = { class: "viet-qr-instruction__list" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  class: "viet-qr-instruction__list viet-qr-instruction__list--mobile mobile"
}
const _hoisted_19 = {
  key: 4,
  class: "viet-qr-instruction"
}
const _hoisted_20 = { class: "viet-qr-instruction__title" }
const _hoisted_21 = { class: "viet-qr-instruction__list" }
const _hoisted_22 = {
  key: 5,
  class: "viet-qr-instruction"
}
const _hoisted_23 = { class: "viet-qr-instruction__title" }
const _hoisted_24 = { class: "viet-qr-instruction__list" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        style: {"max-width":"300px"},
        class: "qr-code",
        src: _ctx.qrCodeUrl
      }, null, 8, _hoisted_3)
    ]),
    (_ctx.vndAmount !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('invoice.viet-qr-amount.label')), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.vndAmountFormatted), 1),
            _createElementVNode("a", {
              class: "copy-link",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.copy(_ctx.$el, String(_ctx.vndAmount))), ["prevent"]))
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", { d: "M6.99994 3.49991C6.99994 3.10208 7.15797 2.72055 7.43928 2.43925C7.72058 2.15794 8.10211 1.99991 8.49994 1.99991H12.3789C12.7766 2.00026 13.1579 2.15852 13.4389 2.43991L16.5609 5.55991C16.7003 5.69938 16.8108 5.86497 16.8862 6.0472C16.9615 6.22943 17.0002 6.42472 16.9999 6.62191V12.4999C16.9999 12.8977 16.8419 13.2793 16.5606 13.5606C16.2793 13.8419 15.8978 13.9999 15.4999 13.9999H14.4999V10.6209C14.4998 9.82532 14.1836 9.06239 13.6209 8.49991L10.4999 5.37891C9.93746 4.81626 9.17452 4.50008 8.37894 4.49991H6.99994V3.49991Z" }),
                _createElementVNode("path", { d: "M4.50006 5.99997C4.10224 5.99997 3.72071 6.15801 3.4394 6.43931C3.1581 6.72061 3.00006 7.10215 3.00006 7.49997V16.5C3.00006 16.8978 3.1581 17.2793 3.4394 17.5606C3.72071 17.8419 4.10224 18 4.50006 18H11.5001C11.8979 18 12.2794 17.8419 12.5607 17.5606C12.842 17.2793 13.0001 16.8978 13.0001 16.5V10.621C12.9997 10.2233 12.8414 9.84201 12.5601 9.56097L9.44006 6.43897C9.30059 6.29958 9.135 6.18907 8.95277 6.11374C8.77054 6.03841 8.57525 5.99975 8.37806 5.99997H4.50006Z" })
              ], -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('invoice.viet-qr-amount.hint')), 1),
          _createElementVNode("div", {
            class: _normalizeClass([{'visible': !!_ctx.copyHintTimeout}, "copy-container"])
          }, _toDisplayString(_ctx.$t('invoice.tooltip.copied')) + ": " + _toDisplayString(_ctx.copyValue), 3)
        ]))
      : _createCommentVNode("", true),
    (_ctx.deal.paymentOption === 'VIET_QR' || _ctx.deal.paymentOption === 'IND_QR' || _ctx.deal.paymentOption === 'BR_QR')
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          class: "viet-qr-save-button",
          href: _ctx.qrCodePngUrl,
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.downloadQr && _ctx.downloadQr(...args)), ["prevent"]))
        }, _toDisplayString(_ctx.$t(_ctx.saveQrLabel)), 9, _hoisted_9))
      : _createCommentVNode("", true),
    (_ctx.deal.paymentOption === 'VIET_QR' && _ctx.vietQrVndWarning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('invoice.viet-qr-vnd-warning.text', {orderSum: _ctx.vndWarningOrderSum, transferSum: _ctx.vndWarningTransferSum})), 1),
          (_ctx.vndTransferSumText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('invoice.viet-qr-vnd-warning.order-sum')) + ": ", 1),
                  _createElementVNode("b", null, _toDisplayString(_ctx.orderSumText), 1)
                ]),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('invoice.viet-qr-vnd-warning.transfer-sum')) + ": ", 1),
                  _createElementVNode("b", null, _toDisplayString(_ctx.vndTransferSumText), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.deal.paymentOption === 'VIET_QR')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('invoice.viet-qr-instruction.title')), 1),
          _createElementVNode("ol", _hoisted_15, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.viet-qr-instruction.step-1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.viet-qr-instruction.step-2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.viet-qr-instruction.step-3', {amount: _ctx.numberFormatter.formatMoney(Number(_ctx.invoice.sum.amount), _ctx.invoice.sum.currency)})), 1),
            (_ctx.vietQrBanks.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_16, _toDisplayString(_ctx.$t('invoice.viet-qr-instruction.step-4-banks', {banks: _ctx.vietQrBanks.map(code => _ctx.$t('methods.' + code)).join(', ')})), 1))
              : (_openBlock(), _createElementBlock("li", _hoisted_17, _toDisplayString(_ctx.$t('invoice.viet-qr-instruction.step-4')), 1)),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.viet-qr-instruction.step-5')), 1)
          ]),
          (_ctx.showVietQrMobileSaveFlow)
            ? (_openBlock(), _createElementBlock("ol", _hoisted_18, [
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.viet-qr-instruction.mobile-step-1')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.viet-qr-instruction.mobile-step-2')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.viet-qr-instruction.mobile-step-3')), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.deal.paymentOption === 'IND_QR')
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('invoice.ind-qr-instruction.title')), 1),
          _createElementVNode("ol", _hoisted_21, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.ind-qr-instruction.step-1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.ind-qr-instruction.step-2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.ind-qr-instruction.step-3')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.deal.paymentOption === 'BR_QR')
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('invoice.br-qr-instruction.title')), 1),
          _createElementVNode("ol", _hoisted_24, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.br-qr-instruction.step-1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.br-qr-instruction.step-2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.br-qr-instruction.step-3')), 1),
            (_ctx.brQrBanks.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_25, _toDisplayString(_ctx.$t('invoice.br-qr-instruction.step-4-banks', {banks: _ctx.brQrBanks.map(code => _ctx.$t('methods.' + code)).join(', ')})), 1))
              : (_openBlock(), _createElementBlock("li", _hoisted_26, _toDisplayString(_ctx.$t('invoice.br-qr-instruction.step-4')), 1)),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('invoice.br-qr-instruction.step-5')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}